document.addEventListener('DOMContentLoaded', function () {


  //-----------------------index featured product slider----------------------
 let maingrid = document.querySelector(".main-grid-col.splide");
if (maingrid) {
  var splide = new Splide(".main-grid-col.splide", {
    type: "slide",
    rewind: false,
    perPage: 2,
    perMove: 1,
    gap: "45px",
    autoplay: false,
    interval: 4000,
    pagination: false,
    drag: true,
    arrows: true,
    breakpoints: {
      1440: {
        gap: "20px",
      },
      989: {
        perPage: 1,
        gap: "15px",
      },
      767: {
        perPage: 2,
      },
      480: {
        perPage: 1,
      },
    },
  });

  var currentEl = splide.root.querySelector(".current-slide");
  var totalEl = splide.root.querySelector(".total-slides");

  // splide.on("mounted move", () => {
  //   // Changed: Select arrows from document instead of splide.root
  //   const prevBtn = document.querySelector(".splide-prev-new");
  //   const nextBtn = document.querySelector(".splide-next-new");

  //   if (!prevBtn || !nextBtn) return;

  //   // Enable/disable arrows
  //   if (splide.index === 0) {
  //     prevBtn.classList.remove("active");
  //   } else {
  //     prevBtn.classList.add("active");
  //   }

  //   if (splide.index === splide.length - splide.options.perPage) {
  //     nextBtn.classList.remove("active");
  //   } else {
  //     nextBtn.classList.add("active");
  //   }

  //   // Click handling
  //   prevBtn.onclick = () => splide.go("<");
  //   nextBtn.onclick = () => splide.go(">");
  // });

  splide.mount();
}


//----------------------------Index Shop by collections---------------------------
  function initFeaturedCategories() {
    if (typeof Splide !== 'undefined') {
      const sliders = document.querySelectorAll('.featured-categories-slider');
      sliders.forEach(function (slider) {
        if (!slider.classList.contains('is-initialized')) {
          new Splide(slider, {
            type: 'slide',
            perPage: 4,
            perMove: 1,
            gap: '20px',
            pagination: false,
            arrows: true,
            autoplay: false,
            breakpoints: {
              1024: {
                perPage: 3,
                gap: '15px',
              },
              749: {
                perPage: 2,
                gap: '10px',
              },
              480: {
                perPage: 1,
                gap: '10px',
              },
            },
          }).mount();
        }
      });
    } else {
      setTimeout(initFeaturedCategories, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeaturedCategories);
  } else {
    initFeaturedCategories();
  }


  


}); // end of document



//product page open preorder dropdown on preirder faq link 
document.addEventListener("DOMContentLoaded", function () {
  const link = document.getElementById("preorder-faq-link");
  const details = document.getElementById("Details-collapsible_tab_4qhJhF-template--21058638446649__main");

  if (link && details) {
    link.addEventListener("click", function () {
      details.setAttribute("open", "true");

      // Optional: scroll to it smoothly
      details.scrollIntoView({ behavior: "smooth" });
    });
  }
});


//-------------------header menu on-hover------------------
// let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
// items.forEach(item => {
//  item.addEventListener("mouseover", () => {
//    item.setAttribute("open", true);
//    item.querySelector("ul").addEventListener("mouseleave", () => {
//      item.removeAttribute("open");
//    });
//  item.addEventListener("mouseleave", () => {
//    item.removeAttribute("open");
//  });
// });
// });

document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".tab-button");
  const contents = document.querySelectorAll(".tab-content");

  buttons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const tabId = btn.getAttribute("data-tab");

      // Remove active states
      buttons.forEach((b) => b.classList.remove("active"));
      contents.forEach((c) => c.classList.remove("active"));

      // Activate selected tab
      btn.classList.add("active");
      document.getElementById(tabId).classList.add("active");
    });
  });
});

function initRelProductSlider(container) {
  const slider = container.querySelector(".relslide");

  if (slider && !slider.classList.contains("splide-initialized")) {
    slider.classList.add("splide-initialized");

    const splide = new Splide(slider, {
      type: "slide",
      perPage: 4,
      perMove: 1,
      gap: "2rem",
      pagination: false,
      arrows: true,
      breakpoints: {
        992: {
          perPage: 2,
          gap: "1.5rem"
        },
        640: {
          perPage: 1,
          gap: "1rem"
        }
      }
    });

    // Move arrows to bottom
    splide.on("mounted", () => {
      const arrows = slider.querySelector(".splide__arrows");

      if (arrows) {
        const bottomWrapper = document.createElement("div");
        bottomWrapper.className = "splide-bottom-arrows";
        bottomWrapper.appendChild(arrows);
        slider.appendChild(bottomWrapper);
      }
    });

    splide.mount();
  }
}

// Watch for Shopify recommendations load
const recommendations = document.querySelector("product-recommendations");
if (recommendations) {
  const observer = new MutationObserver(() => {
    initRelProductSlider(recommendations);
  });
  observer.observe(recommendations, { childList: true, subtree: true });
}

// Run on normal page load
document.addEventListener("DOMContentLoaded", function () {
  initRelProductSlider(document);
});


